import { FC } from 'react';
import styled from 'styled-components';

type FlexColumnProps = {
  gap?: number;
};
/* eslint-disable @typescript-eslint/no-unused-vars */
const FlexColumnComponent: FC<FlexColumnProps> = ({ gap, ...props }) => {
  return <div {...props} />;
};
export const FlexColumn = styled(FlexColumnComponent)`
  display: flex;
  flex-direction: column;
  row-gap: ${({ gap }) => (gap ? `${gap}rem` : '0')};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 1rem;
  label {
    align-items: flex-start;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;
